<template>
  <component :is="layout"></component>
</template>

<script>
import LoginLayout from './components/layouts/LayoutLogin'
import DashboardLayout from './components/layouts/LayoutDashboard'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: { LoginLayout, DashboardLayout },
  computed: mapState(['layout'])
}
</script>
